export enum EnumTpFechamento {
    FimDaVigencia,
    Manualmente,
    DiaDoFechamento,
    Intervalo
};